import { render, staticRenderFns } from "./NiceCaseInfo.vue?vue&type=template&id=48362efd&scoped=true&"
import script from "./NiceCaseInfo.vue?vue&type=script&lang=js&"
export * from "./NiceCaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./NiceCaseInfo.vue?vue&type=style&index=0&id=48362efd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48362efd",
  null
  
)

export default component.exports